import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import ProductCardSlider from "../card/ProductCardSlider";
import {Link} from "react-router-dom";

const products = [{
    "name": "پایه شارژ گوشی موبایل اپل آیفون",
    "img": "./assets/sample-image/HN6K2.png",
    "price": "۲،۷۶۰،۰۰۰ ",
    "discount": "۲،۷۶۰،۰۰۰ ",
    "color_range_1": "#192B3B",
    "color_range_2": "#F5F8FA",
    "color_range_3": "#1473E6",
    "link_product": "s",
    "type_card": "purple",
    "id": 1_1
},
    {
        "name": "کتری هوشمند شیائومی XM200001",
        "img": "./assets/sample-image/XIAOMI-XM200001-Mi-Smart-Kettel--Wasserkocher--Wei.png",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "out-of-stock",
        "id": 2_1
    },
    {
        "name": "هدفون بی‌سیم بیتس مدل Studio 3 – The Beats Skyline Collection",
        "img": "./assets/sample-image/6535256_thumb.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "discount": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "purple",
        "id": 3_1
    },
    {
        "name": "جارو برقی رباتیک هوشمند نسخه 2 شیائومی",
        "img": "./assets/sample-image/XIAOMI-Roborock-S50-Vacuum-Cleaner-Saugroboter--Rund--Wei.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "discount": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "purple",
        "id": 4_1
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "discount": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "purple",
        "id": 5_2
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "discount": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "link_product": "s",
        "color_range_3": "#1473E6",
        "type_card": "purple",
        "id": 6_2
    }]
const SpecialOffer = () => {
    return (
        <div className="special-offer-wrapper xmb-20 xmt-16 ">
            <div className="container">
                <div className="title">
                    <div className="title-box title-box-purple">
                        <div className="title-bg">
                            <h2 className="text">
                                پیشنهاد ویژه
                            </h2>
                            <span className="time timer-interval-box" data-time-offer="november 20, 2021 19:37:25">
                                00:00:00
                            </span>
                        </div>
                        <div className="more d-none d-sm-block">
                            <span><Link to="/specialOfferPage">بیشتر</Link></span>
                            <IconName name="chevron_left" className="icon"/>
                        </div>
                    </div>
                </div>
                <ProductCardSlider data={products} bgPagination="purple"/>
            </div>
        </div>
    );
};

export default SpecialOffer;
